export enum Origin {
	WEB = "Web",
	APP = "App"
}
